import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';
import Footer from '../Templates/Shared/Footer';
import Header from '../Templates/Shared/Header';
// import '../styles/404.css';
import * as styles from '../styles/404.module.scss';
import {navigate} from '@reach/router';
import {data as pageDataJSON} from '../data/404PageData.json';

const ErrorPage = ({data}) => {
  const pageData = {
    ...data,
    ...pageDataJSON,
  };
  const headerContent = pageData.brandWebsiteHeader;
  const footerContent = pageData.brandWebsiteFooter;
  const errorPage = pageData.brandWebsiteHomepage;

  return (
    <div>
      <Header headerContent={headerContent} locale={headerContent.locale} />
      <div className={styles.errorPage}>
        <div className={styles.errorContainer}>
          <div className={styles.errorTexts}>
            <p>4O4</p>
            <div className={styles.errorOops}>
              <p>Oops!</p>
            </div>
            <div className={styles.errorReason}>
              <p>We can&apos;t seem to find the page you are looking for.</p>
            </div>
          </div>
          <a href="/" className={styles.errorPageCta}>
            Go back home
          </a>
        </div>
      </div>
      <Footer
        footerData={footerContent}
        siteMetadata={pageData.site.siteMetadata} />
    </div>
  );
};

ErrorPage.defaultProps = {
  data: {},
};

ErrorPage.propTypes = {
  data: PropTypes.object,
};
export default ErrorPage;

export const pageQuery = graphql`
  query englishHomePageAndEnglishHomePage {
    site {
      siteMetadata {
        social {
          twitter
          facebook
          instagram
          linkedIn
        }
      }
    }
  }
`;
